import * as React from "react";
import { useState } from "react";
import { Stack } from "@origin-digital/ods-core";
import { useFormikContext } from "formik";
import { FormValues } from "../types";
import { apiClient } from "src/api/apiService";
import FormContext from "src/context/FormContext";
import { EICStatusEnum } from "../../Premises/types";
import { sendEicComms } from "../helper";
import { useNavigate } from "react-router-dom";
import OnlineFormAccountHolderDetails from "../OnlineFormAccountHolderDetails";
import { useAppContext } from "../../../context/AppContext";

interface IAccountBlock {
  referenceNumber?: string | null;
  accountPayer?: string | null;
  msaNumber?: string | null;
  projectId?: string | null;
  siteSupervisorId?: string | null;
  dbApplicationId?: string | null;
  journeyId?: string | null;
}

const HomeUserClaimsAccountBlock = (props: IAccountBlock) => {
  const {
    referenceNumber,
    accountPayer,
    msaNumber,
    projectId,
    siteSupervisorId,
    dbApplicationId,
    journeyId,
  } = props;
  const { values, setErrors } = useFormikContext<FormValues>();
  const [savingBlock, setSavingBlock] = useState(false);
  const { setDisplayingSnackbar, setDisplayingAlertBanner } =
    React.useContext(FormContext);
  const {
    context: { user },
  } = useAppContext();
  const navigate = useNavigate();
  const isDigitalEic = values.accountHolderDetailsType === "online";

  const sendEicCommsOnSave = async (premiseId: string, requestId: string) => {
    if (
      isDigitalEic &&
      values.electricityEicStatus !== EICStatusEnum.EIC_ACCEPTED
    ) {
      const { valid, message } = await sendEicComms(
        premiseId,
        requestId,
        "Notification re-sent.",
        "Account failed to save."
      );
      if (valid) {
        setDisplayingAlertBanner(null);
        navigate("/", {
          state: {
            submitted: true,
            isDigitalEic,
            snackbarMessage: message,
          },
        });
      } else {
        setDisplayingSnackbar({
          message,
          tone: valid ? "positive" : "caution",
        });
      }
    }
  };

  const saveAccountBlock = async () => {
    setSavingBlock(true);
    try {
      const { data } = await apiClient.post(`/claim/draft`, {
        reference_number: referenceNumber,
        account_payer: accountPayer,
        msa_number: msaNumber,
        project_id: projectId,
        site_supervisor_id: siteSupervisorId,
        db_application_id: dbApplicationId,
        journey_id: journeyId,
        account_details: {
          first_name:
            accountPayer === "SOMEONE_ELSE"
              ? values.accountPrimaryFirstName
              : user?.first_name,
          last_name:
            accountPayer === "SOMEONE_ELSE"
              ? values.accountPrimaryLastName
              : user?.last_name,
          email:
            accountPayer === "SOMEONE_ELSE"
              ? values.accountPrimaryEmail
              : user?.email,
          is_digital_eic: true,
        },
      });
      setSavingBlock(false);
      setDisplayingSnackbar({
        message: "Account saved",
        tone: "positive",
      });
      await sendEicCommsOnSave(data.premise.id, data.services?.[0]?.request_id);
    } catch (e) {
      console.error("Failed to save account:", e);
      setDisplayingSnackbar({
        message: "Failed to save account",
        tone: "caution",
      });
      setSavingBlock(false);
    }
  };

  console.log("here");

  return (
    <>
      <Stack
        space={{
          xs: "xlarge",
          md: "xxlarge",
        }}
      >
        <OnlineFormAccountHolderDetails
          values={values}
          setErrors={setErrors}
          savingBlock={savingBlock}
          setSavingBlock={setSavingBlock}
          saveAccountBlock={saveAccountBlock}
          homeUser={true}
          isLodgingClaim={true}
          saveButtonText="Lodge claim"
        />
      </Stack>
      {/* </Accordion> */}

      {/* End Premise section */}
    </>
  );
};

export default HomeUserClaimsAccountBlock;
